import React from 'react';
import { MessageCircle, Sparkles, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const AskDrNawwafSection = () => {
  const { t } = useLanguage();

  const handleStartChat = () => {
    window.open('https://www.ask-dr-nawwaf.com', '_blank');
  };

  return (
    <section id="ask-dr-nawwaf" className="py-16" style={{
      background: 'linear-gradient(180deg, #1f1340 0%, #1a0f38 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image with 3D Glowing Frame */}
          <div className="relative flex justify-center">
            {/* Outer Glow */}
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-2xl bg-gradient-to-br from-pink-500/30 via-purple-500/20 to-blue-500/30 blur-xl" />
            </div>
            
            {/* 3D Frame Container */}
            <div className="relative">
              {/* 3D Edge Effect - Back layer */}
              <div 
                className="absolute -inset-1 rounded-2xl"
                style={{
                  background: 'linear-gradient(135deg, #f472b6 0%, #c084fc 50%, #60a5fa 100%)',
                  transform: 'translate(4px, 4px)',
                  filter: 'blur(1px)'
                }}
              />
              
              {/* 3D Edge Effect - Middle layer */}
              <div 
                className="absolute -inset-0.5 rounded-2xl"
                style={{
                  background: 'linear-gradient(135deg, #ec4899 0%, #a855f7 50%, #3b82f6 100%)',
                  boxShadow: '0 0 30px rgba(236, 72, 153, 0.5), 0 0 60px rgba(168, 85, 247, 0.3)'
                }}
              />
              
              {/* Main Image Container */}
              <div 
                className="relative w-72 h-72 lg:w-80 lg:h-80 rounded-xl overflow-hidden"
                style={{
                  boxShadow: 'inset 0 0 20px rgba(0,0,0,0.5), 0 10px 40px rgba(0,0,0,0.5)'
                }}
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_alshibli-website/artifacts/8odljuft_hf_20260130_085011_e24f602e-ae95-4407-b94f-9534713e1718.png"
                  alt="Ask Dr. Nawwaf AI Chat"
                  className="w-full h-full object-cover"
                />
                
                {/* Inner glow overlay */}
                <div className="absolute inset-0 rounded-xl" style={{
                  boxShadow: 'inset 0 0 30px rgba(236, 72, 153, 0.3), inset 0 0 60px rgba(168, 85, 247, 0.2)'
                }} />
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="text-left">
            <div className="inline-flex items-center gap-2 bg-pink-600/20 border border-pink-500/30 text-pink-300 px-4 py-2 rounded-full text-sm mb-6">
              <Sparkles className="w-4 h-4" />
              {t('aiPowered')}
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              {t('askDrTitle')}
            </h2>
            <h3 className="text-xl text-pink-400 mb-6">
              {t('askDrSubtitle')}
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed">
              {t('askDrDesc')}
            </p>
            <Button 
              onClick={handleStartChat}
              className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white px-8 py-6 text-lg rounded-xl flex items-center gap-3"
            >
              <MessageCircle className="w-5 h-5" />
              {t('startChatting')}
              <ExternalLink className="w-4 h-4 ml-1" />
            </Button>
            <p className="text-gray-500 text-sm mt-4">
              {t('responsesNote')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AskDrNawwafSection;
